import { useTranslation } from 'react-i18next';

import { AppBar } from '../../../Molecules';
import {
  SubscriptionCard,
  SubscriptionCardProps,
} from '../../../Molecules/SubscriptionCard';

import styles from './SubscriptionTemplate.module.css';

type SubscriptionTemplateProps = {
  currentPlanProps: SubscriptionCardProps;
  upgradePlansProps: SubscriptionCardProps[];
  downgradePlansProps: SubscriptionCardProps[];
};

export const SubscriptionTemplate = ({
  currentPlanProps,
  upgradePlansProps,
  downgradePlansProps,
}: SubscriptionTemplateProps) => {
  const { t } = useTranslation();
  return (
    <div className={styles.container}>
      <AppBar />
      <div
        className={styles.list}
        style={{
          padding: `${
            currentPlanProps === undefined ? '1rem' : '1.8rem 1rem 1rem 1rem'
          }`,
        }}
      >
        <SubscriptionCard {...currentPlanProps} />
        {upgradePlansProps.length > 0 && (
          <p className={styles.sectionTitle}>{t('Upgrade Subscription')}</p>
        )}
        {upgradePlansProps.map((upgradePlanProps) => (
          <SubscriptionCard key={upgradePlanProps.tier} {...upgradePlanProps} />
        ))}
        {downgradePlansProps.length > 0 && (
          <p className={styles.sectionTitle}>{t('Downgrade Subscription')}</p>
        )}
        {downgradePlansProps.map((downgradePlanProps) => (
          <SubscriptionCard
            key={downgradePlanProps.tier}
            {...downgradePlanProps}
          />
        ))}
      </div>
    </div>
  );
};
